export default __webpack_public_path__ + "static/media/RO04.ae73355f.jpg";